// extracted by mini-css-extract-plugin
export default {"editButton":"advancesalary_editButton__A7ddR","TableBody":"advancesalary_TableBody__w6sHT"};